import anime from 'animejs'
import {
  createAnimation
} from '../utils/createAnimation'
import {
  characterWalk
} from '../utils/characterWalk'
import {
  createRotateAnimation
} from '../utils/createRotateAnimation'
import {
  create
} from 'domain'; // what is this?

const riaAnimations = () => {
  return {
    enter(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 3500
        tl
          .add({
            targets: '#ria',
            translateY: characterWalk(options.duration, 20, 1250),
            left: ['-20%', '25%'],
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    exit(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 3500
        tl
          .add({
            targets: '#ria',
            scaleX: {
              value: -1,
              duration: 1
            }, // flip ria
            translateY: characterWalk(options.duration),
            left: ['25%', '-20%'],
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    walkInPlace(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 8000
        options.flipped = options.flipped || false
        options.left = options.left || ['36%', '20%']
        tl
          .add({
            targets: '#ria',
            scaleX: {
              value: options.flipped ? -1 : 1,
              duration: 1
            }, // flip ria conditionally
            left: options.left,
            translateY: characterWalk(options.duration),
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    rotate(options) { // not used in module 3
      return createAnimation(createRotateAnimation('#ria'), options, this)()
    },
    raiseLeftArm(options) {
      return createAnimation((tl, options) => {
        if (options.half) {
          tl
            .add({
              targets: "#ria_left_arm",
              rotate: '-15deg',
              easing: 'linear',
              duration: 350,
              begin: options.begin
            })
            .add({
              targets: "#ria_left_arm_hand",
              rotate: '-75deg',
              easing: 'linear',
              duration: 350,
              complete: options.complete
            })
        } else {
          tl
            .add({
              targets: "#ria_left_arm",
              rotate: '-15deg',
              easing: 'linear',
              duration: 350,
              begin: options.begin
            })
            .add({
              targets: "#ria_left_arm_hand",
              rotate: '-140deg',
              easing: 'linear',
              duration: 350,
              complete: options.complete
            })
        }
      }, options, this)()
    },
    raiseRightArm(options) {
      return createAnimation((tl, options) => {
        if (options.quarter) {
          tl
            .add({
              targets: "#ria_right_arm_hand",
              rotate: '-90deg',
              easing: 'linear',
              duration: 350,
              begin: options.begin,
              complete: options.complete
            })
        } else if (options.half) {
          tl
            .add({
              targets: "#ria_right_arm",
              rotate: '15deg',
              easing: 'linear',
              duration: 350,
              begin: options.begin
            })
            .add({
              targets: "#ria_right_arm_hand",
              rotate: '-105deg',
              easing: 'linear',
              duration: 350,
              complete: options.complete
            })
        } else {
          tl
            .add({
              targets: "#ria_right_arm",
              rotate: '-12deg',
              easing: 'linear',
              duration: 350,
              begin: options.begin
            })
            .add({
              targets: "#ria_right_arm_hand",
              rotate: '-90deg',
              easing: 'linear',
              duration: 350,
              complete: options.complete
            })
        }
      }, options, this)()
    },
    lowerRightArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '0deg',
            easing: 'linear',
            duration: 350,
            begin: options.begin
          })
          .add({
            targets: "#ria_right_arm",
            rotate: '0deg',
            easing: 'linear',
            duration: 350,
            complete: options.complete
          })
      }, options, this)()
    },
    lowerLeftArm(options) {
      return createAnimation((tl, options) => {
        tl

          .add({
            targets: "#ria_left_arm_hand, #ria_left_arm_hand_touch",
            rotate: '0deg',
            easing: 'linear',
            duration: 400,
            begin: options.begin
          })
          .add({
            targets: "#ria_left_arm_hand_touch",
            opacity: 0,
            duration: 1,
            easing: "linear"
          })
          .add({
            targets: "#ria_left_hand_touch",
            scaleX: 1,
            rotate: "15deg",
            duration: 1,
            easing: "linear"
          })
          .add({
            targets: "#ria_left_arm_hand",
            opacity: 1,
            duration: 1,
            easing: "linear"
          })
          .add({
            targets: "#ria_left_arm, #ria_left_arm_touch",
            rotate: '0deg',
            easing: 'linear',
            duration: 350,
            complete: options.complete
          })
      }, options, this)()
    },
    wave(options) {
      return createAnimation((tl, options) => {
        tl
          // full raised arm
          .add({
            targets: "#ria_right_arm",
            rotate: '-25deg',
            easing: 'linear',
            duration: 350,
            begin: options.begin
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-110deg',
            easing: 'linear',
            duration: 300
          })
          // wave
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-120deg',
            easing: 'linear',
            duration: 300,
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-110deg',
            easing: 'linear',
            duration: 300
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-120deg',
            easing: 'linear',
            duration: 300,
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-110deg',
            easing: 'linear',
            duration: 300,
            complete: () => {
              this.lowerRightArm({
                delay: 350,
                complete: options.complete
              })
            }
          })
      }, options, this)()
    },
    laugh(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#ria_right_arm",
            rotate: '-35deg',
            easing: 'linear',
            duration: 300,
            begin: options.begin
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-135deg',
            easing: 'linear',
            duration: 300,
            // complete: options.complete
          })
          .add({ // move outer arm group up/down
            targets: '#ria_right_arm_outer',
            translateY: [{
                value: '-3px',
                duration: 150
              },
              {
                value: '0px',
                duration: 150
              },
              {
                value: '-3px',
                duration: 150
              },
              {
                value: '0px',
                duration: 150
              }
            ],
            easing: "linear",
            complete: () => {
              this.lowerRightArm({
                delay: 350,
                complete: options.complete
              })
            }
          })
      }, options, this)()
    },
    touchChin(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#ria_left_arm, #ria_left_arm_touch",
            rotate: '-15deg',
            easing: 'linear',
            duration: 350,
            begin: options.begin
          })
          .add({
            targets: "#ria_left_arm_hand",
            opacity: 0,
            duration: 1,
            easing: "linear"
          })
          .add({
            targets: "#ria_left_hand_touch",
            scaleX: -1,
            rotate: "15deg",
            duration: 1,
            easing: "linear"
          })
          .add({
            targets: "#ria_left_arm_hand_touch",
            opacity: 1,
            duration: 1,
            easing: "linear"
          })
          .add({
            targets: "#ria_left_arm_hand, #ria_left_arm_hand_touch",
            rotate: '170deg',
            easing: 'linear',
            duration: 400,
            complete: options.complete
          })
      }, options, this)()
    }
  }
}

export {
  riaAnimations
}

// todo for module 6:
// artboard 49 -> all the way raised arm
// chin animation
// tweak left and right raises maybe



// WEBPACK FOOTER //
// ./src/assets/js/characters/riaAnimations.js